import { InlineIcon } from '@iconify/react';
import { Divider, Tag } from 'rsuite';
import { cssVars } from '@/app/styles';
import { SIDEBAR_WIDTH } from '@/map/map-constants';
import styled from 'styled-components';

export const SidebarWrapper = styled.div`
  display: flex;
  position: absolute;
  height: calc(100% - 40px);
  left: 20px;
  bottom: 20px;
  width: 100%;
  border-radius: 4px;
`;

const ResultRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 14px;
`;

export const FilterResultWrapper = styled(ResultRow)`
  width: ${SIDEBAR_WIDTH}px;
  margin-top: 25px;
  margin-bottom: 0;
`;

export const ResultNumber = styled(ResultRow)`
  margin-left: 24px;
  font-weight: 600;
  color: #101938;
`;

export const TotalNumber = styled(ResultRow)`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
`;

export const ResultText = styled(ResultRow)`
  margin-left: 6px;
  font-size: 12px;
  text-align: right;
  color: #101938;
`;

export const SectionWrapper = styled.div`
  width: ${SIDEBAR_WIDTH}px;
  margin-top: 20px;
  margin-left: 24px;

  display: flex;
  flex-direction: column;
`;

export const StyledDivider = styled(Divider)`
  margin-bottom: 8px;
  margin-top: 14px;
`;

export const ItemWrapper = styled.div`
  height: 28px;
  // margin-top: 5px;
  margin-left: ${(props) => (props.eye ? '0' : '-10px')};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .rs-checkbox label {
    height: 20px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.85);

    display: flex;
    align-items: center;
  }

  .rs-checkbox-checker {
    padding-top: 8px;
    padding-left: ${(props) => (props.eye ? '0' : '36px')};
  }

  .rs-checkbox-wrapper {
    display: ${(props) => (props.eye ? 'none' : 'unset')};
  }
`;

export const SectionTitle = styled.span`
  height: 20px;
  margin-bottom: 14px;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.5);
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
`;

export const OccupancySliderWrapper = styled.div`
  display: flex;
  flex-direction: flex-start;
`;

export const OccupancyCheckboxWrapper = styled.div`
  display: flex;

  .rs-checkbox {
    right: 10px;
  }

  .rs-checkbox label {
    height: 20px;
    font-family: 'Nunito Sans', sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.85);

    display: flex;
    align-items: center;
  }

  .rs-checkbox-checker {
    padding-top: 8px;
  }
`;

export const OccupancySliderBar = styled.div`
  padding-left: 5px;
  padding-top: 10px;
  width: 60%;

  .rs-slider-bar {
    background-color: #34c3ff;
  }

  .rs-slider-progress-bar {
    background-color: #f2f2f5;
  }
`;

// occupancy value in the center
export const OccupancySliderValue = styled.div`
  width: 40%;
  padding-top: 4px;

  display: flex;
  justify-content: center;
`;

export const PropertyCountWrapper = styled.span`
  margin-left: 4px;
  height: 14px;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.5);
`;

export const OccupancyPropertyCountWrapper = styled(PropertyCountWrapper)`
  padding-top: 12px;
`;

export const PropertyValueInputGroup = styled.div`
  margin-top: 8px;

  display: flex;

  .rs-input-group.rs-input-number.rs-input-group-xs {
    width: 40% !important;
  }
`;

export const TagWrapper = styled.div`
  z-index: 1;
  position: absolute;
  // left: 253px;
  left: ${(props) => (props.isSidebarHidden ? '30px' : '312px')};
  transition: left 0.5s ease-in;
  /* TODO: Use variables. 350px is sidebar width + toggle button width + their margins */
  width: calc(100% - ${cssVars.sidebarWidth});

  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`;

export const StyledTag = styled(Tag)`
  margin-bottom: 6px;
  margin-left: 6px !important;

  height: 24px;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;

  .rs-tag-text {
    height: 16px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.85);
  }

  .rs-tag-icon-close:after {
    color: rgba(0, 0, 0, 0.85);
  }
`;

export const StyledInlineIcon = styled(InlineIcon)`
  width: 16px;
  height: 16px;
  color: #37a3bc;
  margin-right: 7px;
  cursor: pointer;
`;
